import { useEffect } from "react";

import { Button, Modal, Text, useDisclosure } from "@alpacahq/ui/old";

export const AlpacaXCryptoModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  // biome-ignore lint/correctness/useExhaustiveDependencies: deliberately mount-only: the modal is opened once when this component mounts. onOpen is a caller-supplied callback, so listing it would reopen the modal on every render.
  useEffect(() => {
    onOpen();
  }, []);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Notice">
      <div>
        <Text>You are now going to open an account with</Text>
        <Text>- Alpaca Securities LLC,</Text>
        <Text>- Alpaca Crypto LLC</Text>
      </div>
      <div>
        <Button onClick={onClose}>Ok</Button>
      </div>
    </Modal>
  );
};
